import {useEffect} from "react";
import {onEngineEvent} from "./engineLink";

// Pumps an element on the show's beat clock (the engine's): a quick swell on every beat, bigger on the downbeat,
// decaying before the next — what VDMX's zoom did to the title logo.
export const useBeatPump = (ref, {scale = 0.06, glow = 0.45} = {}) => {
    useEffect(() => {
        let beat = null, raf;
        const off = onEngineEvent(e => {
            if (e.type === 'beat') beat = e;
            // a jump starts the next block before the last one's sound has stopped: only its own stop ends the beat
            if (e.type === 'block-playback' && e.state !== 'playing' && beat && e.block === beat.block) beat = null;
        });
        const tick = () => {
            const el = ref.current;
            if (el) {
                let k = 0;
                if (beat) {
                    const b = (Date.now() - beat.phaseOrigin) * beat.bpm / 60000;
                    if (b >= 0) k = (Math.floor(b) % (beat.beatsPerBar || 4) === 0 ? 1.4 : 1) * Math.exp(-(b - Math.floor(b)) * 6);
                }
                el.style.transform = `scale(${1 + scale * k})`;
                el.style.filter = k > 0.01 ? `brightness(${1 + glow * k})` : '';
            }
            raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => { off(); cancelAnimationFrame(raf); };
    }, [ref, scale, glow]);
};
